import { env } from "utility/config";
import { toast } from "react-toastify";
import { SC, errorHandler } from "utility/helper";

export const handleFileUploader = async ({ file, ...props }) => {
  const formData = new FormData();
  formData.append("file", file);

  SC.postAttachment({
    url: props?.url,
    data: formData,
    callbackProgressUpload: (e) => props.progressCB(e),
  }).then(
    (response) => {
      const attachment = response?.data?.data?.files || response?.data?.data?.log;
      // toast.success("File uploaded successfully!");
      props.handleUpload({
        stepIndex: props.stepIndex,
        key: props.name,
        value: attachment,
        // step: props.step || 0,
      });

      return attachment;
    },
    (error) => {
      const err = errorHandler(error);
      props.handleUpload({
        error: err.toString(),
      });
      toast.error(err);
    },
  );
};

export const uploadFileS3 = async (file, callBackS3, progressCB) => {
  if (!file) {
    callBackS3({ error: "No file found" });
    return;
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("project", env.AWS_BUCKET);

  const key = `${Date.now()}_${file?.name}`;

  try {
    const response = await fetch(env.MICRO_HELPER_URL, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Unable to upload file");
    }

    const data = await response.json();
    const filePath = data?.paths || data?.path || data?.Location || data?.location || data?.url;

    if (!filePath) {
      throw new Error("Upload service did not return a file path");
    }

    progressCB(100);
    callBackS3({
      Location: filePath,
      key,
    });
  } catch (error) {
    progressCB(100);
    callBackS3({ error: error?.message || error.toString() });
  }
};
